<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
let time=null
export default {
  name: 'App',
  data(){
    return{

    }
  },
  // 使用watch 监听$router的变化,
//   watch: {
//     '$route': function(to,from){
// 　    document.body.scrollTop = 0
//       document.documentElement.scrollTop = 0
//       // console.log(to)
//       if(to.fullPath=="/zccz"){
//         this.$store.commit("setDzfvalue", 0);
//       }
//     }
//   },
  methods:{
    //页面加载完成后访问量+1
    firstTimeStages(){
      var firstTime=sessionStorage.getItem("firstTime");
      // console.log(firstTime)
      if(!(firstTime!=null&&firstTime!="")){
        // console.log("访问量+1"); 
        var that=this;
        that.axios({
          method:'post',
          url:'/api/index/setFirstTimeStage'
        }).then(res=>{
          // console.log(res.data);
          sessionStorage.setItem("firstTime",res.data);
        })    
      }
    },
    currentTime(){
      if(time){
        window.clearTimeout(time);
        time=null;
      }
      time=window.setTimeout(()=>{
        this.$message({
          message:'登录超时，将返回登录页',
          type:'error',
          duration:1500
        })
        setTimeout(()=>{
          this.$router.push("/")
      },2000)
      },1000*60*30)
    },
  },
  created(){
    this.firstTimeStages();
    window.addEventListener('click',()=>{
      if(this.$router.path!='/login'){
        this.currentTime();
      }
    })
  }
}

</script>

<style>
@import './style/common.css';
body,html,#app{
  width: 100%;
  height: 100%;
  margin:0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue